export enum MoneyFormatDisplayMode {
  SYMBOL = 'symbol',
  CODE = 'code',
  NAME = 'name'
}

export interface MoneyFormatProps {
  amount: number;
  currency: string;
  displayMode?: MoneyFormatDisplayMode;
}



// WEBPACK FOOTER //
// ./src/components/MoneyFormat/types.ts